/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const PurchasePlanningService = {

  async getGenerateData() {
    const url = `api/PurchasePlanningGenerate`;
    return await ApiService.post(url, {
      "RunId": "00000000-0000-0000-0000-000000000000",
      "SalesOrder": 0
    });
  },

  async dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getCustomData(params) {

    const requestScreenData = {
      url: "api/" + params.url,
      filter: params.filter,
      select: params.select,
      expand: params.expand ? params.expand : undefined,
      orderby: params.orderby ? params.orderby : undefined
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async savePurchasePlanning(payload, id) {
    const url = `api/Save_PurchasePlanningData`;

    if (id) {
      return await ApiService.put(url, id, payload, "Integer");
    } else {
      return await ApiService.post(url, payload);
    }
  },
};

export { PurchasePlanningService };
